import { useState, useEffect, useCallback } from "react";
import { collection, query, orderBy, limit, getDocs, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

/**
 * CRUD para patients/{id}/qol_records
 * Usado por pacientes para guardar historial de cuestionarios (LYMQOL, Lymph-ICF)
 */
export default function useQolRecords(patientId) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    if (!patientId) { setLoading(false); return; }
    setLoading(true);
    try {
      const q = query(
        collection(db, "patients", patientId, "qol_records"),
        orderBy("fecha", "desc"),
        limit(10)
      );
      const snap = await getDocs(q);
      setRecords(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error("useQolRecords:", err.message);
    } finally {
      setLoading(false);
    }
  }, [patientId]);

  useEffect(() => { load(); }, [load]);

  const addRecord = useCallback(async (data) => {
    if (!patientId) throw new Error("No patientId");
    setSaving(true);
    try {
      await addDoc(collection(db, "patients", patientId, "qol_records"), {
        ...data,
        fecha: serverTimestamp(),
      });
      await load();
    } catch (err) {
      console.error("useQolRecords add:", err.message);
      throw err;
    } finally {
      setSaving(false);
    }
  }, [patientId, load]);

  return { records, loading, saving, addRecord };
}
